interface WindowFeatures {
    top: string | number;
    left: string | number;
    screenX: string | number;
    screenY: string | number;
    width: string | number;
    height: string | number;
    menubar: boolean;
    toolbar: boolean;
    location: boolean;
    status: boolean;
    resizable: boolean;
    scrollbars: boolean;
    noopener: boolean;
    noreferrer: boolean;
}

export function usePopup(
    url?: string | URL,
    target?: string,
    features: Partial<WindowFeatures> = {},
): WindowProxy | null {
    const windowFeatures = [];

    for (const key of Object.keys(features) as (keyof WindowFeatures)[]) {
        if (
            typeof features[key] === "number" ||
            typeof features[key] === "string"
        )
            windowFeatures.push(`${key}=${features[key]}`);
        else if (features[key]) windowFeatures.push(`${key}`);
    }

    return window.open(
        url,
        target,
        windowFeatures.length ? windowFeatures.join(",") : undefined,
    );
}
